export default __webpack_public_path__ + "locales/ja-JP/Errors.json?hash=e5406d5f56d41df76da6f4a431060971";